import React, { FC } from 'react';
import { BlackScreen, SuccessEl, СorrectShare, IconContainer } from './common-styles';
import { Icon } from 'kl-b2c-ui-kit';

interface Props {
    close: () => void;
    gradient?: string;
    color?: string;
    gap?: number;
    title?: string;
    text?: string;
    additionalText?: string;
}

const Success: FC<Props> = ({ close, gradient, color, gap, title, text, additionalText }) => {
    title = title ?? 'Thank you for your interest in the SAS 2026!';
    text = text ?? 'We will get back to you shortly';
    return (
        <BlackScreen>
            <SuccessEl gradient={gradient} color={color} gap={gap}>
                {!gradient && <СorrectShare />}
                <IconContainer onClick={close}>
                    <Icon name={'CrossThin'} hoverColor="white" size={24} color={'gray'} />
                </IconContainer>

                <div className="root">
                    <h4>{title}</h4>
                    <p>{text}</p>
                    {additionalText && <p>{additionalText}</p>}
                </div>
            </SuccessEl>
        </BlackScreen>
    );
};

export default Success;
